import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { Fonts, Spacings, breakpoints } from '@styles/index';

const H5 = styled.h5`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H5};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    font-size: 14px;
  }
  @media only screen and (max-width: 47.95em) {
    font-size: 16px;
  }
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default H5;

H5.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H5.defaultProps = {
  color: 'var(--color-text-primary)',
  lineClamp: null
};
